import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const TableContext = /*#__PURE__*/createContext({
  bordered: true,
  condensed: true,
  _exteriorBorders: true,
  tableVariantStyleOverrides: {}
});
export const TableProvider = ({
  bordered,
  condensed,
  _exteriorBorders,
  tableVariantStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(TableContext.Provider, {
    value: {
      bordered,
      condensed,
      _exteriorBorders,
      tableVariantStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `Table` component.
 * @returns TableContext - The context for the `Table` component.
 */
export const useTableContext = () => {
  return useContext(TableContext);
};